import { navigateTo } from '#app'
import { routes } from '~/routes'

// TODO: featured 바뀌면 제거
export default defineNuxtRouteMiddleware((to, from) => {
  // 기존 7월
  if (to.params.featuredId === 'supervillian-labs-rises' || to.params.featuredId === 'supervillain-labs-rises') {
    return navigateTo(routes.getFeaturedPage(to.params.projectId as string, '66fa039331b7ec1157dd2112'))
  }
  // 기존 8월
  if (to.params.featuredId === 'august-spotlight') {
    return navigateTo(routes.getFeaturedPage(to.params.projectId as string, '66f65e366d25de35f11dfc1d'))
  }
})